<template>
  <section
    v-if="variants.v1 === variant && sidebarComponents.length === 0"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="tw-flex tw-w-full tw-max-w-lg tw-flex-col tw-items-center tw-text-black lg:tw-max-w-none">
      <div
        class="tw-flex tw-flex-col tw-items-start tw-justify-between tw-gap-4 tw-self-start lg:tw-w-full lg:tw-flex-row lg:tw-items-center"
      >
        <div v-html="vars.titleHtml" class="tw-flex tw-flex-wrap tw-items-start tw-gap-x-3"></div>
        <nuxt-link :external="true" :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText}`">{{
          vars.buttonLabelText
        }}</nuxt-link>
      </div>
      <div class="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-gap-10 tw-pt-10 lg:tw-flex-col-reverse">
        <Swiper
          :modules="[SwiperPagination]"
          :pagination="false"
          :slides-per-view="1"
          :space-between="20"
          effect="fade"
          :clickable="true"
          :watch-overflow="true"
          :loop="true"
          @slideChange="onSlideChange"
          :breakpoints="{
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          }"
          @swiper="onSwiper"
          class="tw-w-full tw-max-w-lg lg:tw-max-w-full"
        >
          <SwiperSlide
            v-for="(property, index) in properties"
            :key="`latestproperties-property-${index}`"
            class="!tw-flex !tw-h-auto"
          >
            <theme5-properties-property-list-item
              :property="property"
              :is-match-information-hidden="true"
              :feature-count-number="vars.featureCountNumber"
              :index="index"
              :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
            />
          </SwiperSlide>
          <div class="controls xl:!tw-hidden">
            <div
              data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569daf"
              class="slide-left-arrow w-slider-arrow-left"
              :isDisabled="!canPaginateBack"
              @click="() => swiper.slidePrev()"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.011 3.49956C16.1418 3.6335 16.2151 3.81332 16.2151 4.00056C16.2151 4.18781 16.1418 4.36762 16.011 4.50156L8.70149 12.0001L16.011 19.4971C16.1418 19.631 16.2151 19.8108 16.2151 19.9981C16.2151 20.1853 16.1418 20.3651 16.011 20.4991C15.9474 20.5644 15.8714 20.6163 15.7874 20.6517C15.7034 20.6872 15.6132 20.7054 15.522 20.7054C15.4308 20.7054 15.3406 20.6872 15.2566 20.6517C15.1726 20.6163 15.0966 20.5644 15.033 20.4991L7.25999 12.5236C7.12347 12.3835 7.04706 12.1957 7.04706 12.0001C7.04706 11.8045 7.12347 11.6166 7.25999 11.4766L15.033 3.50106C15.0966 3.43575 15.1726 3.38383 15.2566 3.34839C15.3406 3.31294 15.4308 3.29468 15.522 3.29468C15.6132 3.29468 15.7034 3.31294 15.7874 3.34839C15.8714 3.38383 15.9474 3.43575 16.011 3.50106V3.49956Z"
                  fill="#6EADAB"
                />
              </svg>
              <div class="slide-circle slider-circle-transform"></div>
            </div>
            <div
              data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569db1"
              class="slide-right-arrow w-slider-arrow-right"
              :isDisabled="!canPaginateNext"
              @click="() => swiper.slideNext()"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.98901 3.49956C7.85817 3.6335 7.78491 3.81332 7.78491 4.00056C7.78491 4.18781 7.85817 4.36762 7.98901 4.50156L15.2985 12.0001L7.98901 19.4971C7.85817 19.631 7.78491 19.8108 7.78491 19.9981C7.78491 20.1853 7.85817 20.3651 7.98901 20.4991C8.0526 20.5644 8.12864 20.6163 8.21263 20.6517C8.29661 20.6872 8.38685 20.7054 8.47801 20.7054C8.56917 20.7054 8.65941 20.6872 8.74339 20.6517C8.82738 20.6163 8.90342 20.5644 8.96701 20.4991L16.74 12.5236C16.8765 12.3835 16.9529 12.1957 16.9529 12.0001C16.9529 11.8045 16.8765 11.6166 16.74 11.4766L8.96701 3.50106C8.90342 3.43575 8.82738 3.38383 8.74339 3.34839C8.65941 3.31294 8.56917 3.29468 8.47801 3.29468C8.38685 3.29468 8.29661 3.31294 8.21263 3.34839C8.12864 3.38383 8.0526 3.43575 7.98901 3.50106V3.49956Z"
                  fill="#6EADAB"
                />
              </svg>
              <div class="slide-circle right"></div>
            </div>
          </div>
        </Swiper>
      </div>
    </div>
  </section>

  <div
    v-else-if="variants.v1 === variant && sidebarComponents.length > 0"
    class="latest-properties-sidebar tw-px-6 tw-py-8"
    style="border-radius: var(--rounded)"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <h3 class="tw-pb-6">{{ vars.titleHtml }}</h3>
    <Swiper
      :modules="[SwiperPagination]"
      :pagination="false"
      :slides-per-view="1"
      :space-between="20"
      :loop="true"
      effect="fade"
      :clickable="true"
      :watch-overflow="true"
      @slideChange="onSlideChange"
      :breakpoints="{
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
      }"
      @swiper="onSwiper"
      class="tw-w-full tw-max-w-lg lg:tw-max-w-full"
    >
      <SwiperSlide
        v-for="(property, index) in properties"
        :key="`latestproperties-property-${index}`"
        class="!tw-flex !tw-h-auto"
      >
        <theme5-properties-property-list-item
          :property="property"
          :is-match-information-hidden="true"
          :feature-count-number="vars.featureCountNumber"
          :index="index"
          :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
        />
      </SwiperSlide>
      <div class="controls">
        <div
          data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569daf"
          class="slide-left-arrow w-slider-arrow-left tw-bg-[#F7FBF3]"
          :isDisabled="!canPaginateBack"
          @click="() => swiper.slidePrev()"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16.011 3.49956C16.1418 3.6335 16.2151 3.81332 16.2151 4.00056C16.2151 4.18781 16.1418 4.36762 16.011 4.50156L8.70149 12.0001L16.011 19.4971C16.1418 19.631 16.2151 19.8108 16.2151 19.9981C16.2151 20.1853 16.1418 20.3651 16.011 20.4991C15.9474 20.5644 15.8714 20.6163 15.7874 20.6517C15.7034 20.6872 15.6132 20.7054 15.522 20.7054C15.4308 20.7054 15.3406 20.6872 15.2566 20.6517C15.1726 20.6163 15.0966 20.5644 15.033 20.4991L7.25999 12.5236C7.12347 12.3835 7.04706 12.1957 7.04706 12.0001C7.04706 11.8045 7.12347 11.6166 7.25999 11.4766L15.033 3.50106C15.0966 3.43575 15.1726 3.38383 15.2566 3.34839C15.3406 3.31294 15.4308 3.29468 15.522 3.29468C15.6132 3.29468 15.7034 3.31294 15.7874 3.34839C15.8714 3.38383 15.9474 3.43575 16.011 3.50106V3.49956Z"
              fill="#6EADAB"
            />
          </svg>
          <div class="slide-circle slider-circle-transform"></div>
        </div>
        <div
          data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569db1"
          class="slide-right-arrow w-slider-arrow-right"
          :isDisabled="!canPaginateNext"
          @click="() => swiper.slideNext()"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.98901 3.49956C7.85817 3.6335 7.78491 3.81332 7.78491 4.00056C7.78491 4.18781 7.85817 4.36762 7.98901 4.50156L15.2985 12.0001L7.98901 19.4971C7.85817 19.631 7.78491 19.8108 7.78491 19.9981C7.78491 20.1853 7.85817 20.3651 7.98901 20.4991C8.0526 20.5644 8.12864 20.6163 8.21263 20.6517C8.29661 20.6872 8.38685 20.7054 8.47801 20.7054C8.56917 20.7054 8.65941 20.6872 8.74339 20.6517C8.82738 20.6163 8.90342 20.5644 8.96701 20.4991L16.74 12.5236C16.8765 12.3835 16.9529 12.1957 16.9529 12.0001C16.9529 11.8045 16.8765 11.6166 16.74 11.4766L8.96701 3.50106C8.90342 3.43575 8.82738 3.38383 8.74339 3.34839C8.65941 3.31294 8.56917 3.29468 8.47801 3.29468C8.38685 3.29468 8.29661 3.31294 8.21263 3.34839C8.12864 3.38383 8.0526 3.43575 7.98901 3.50106V3.49956Z"
              fill="#6EADAB"
            />
          </svg>
          <div class="slide-circle right"></div>
        </div>
      </div>
    </Swiper>
  </div>

  <section
    class="n-section-primary"
    v-if="variants.v2 === variant && sidebarComponents.length === 0"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="tw-flex tw-w-full tw-max-w-none tw-flex-col tw-items-center lg:tw-max-w-none lg:tw-items-center">
      <div
        class="tw-mb-6 tw-flex tw-flex-wrap tw-justify-center tw-self-center tw-text-center tw-text-black lg:tw-mb-12 xl:tw-mb-6 xl:tw-gap-4"
        v-html="vars.titleHtml"
      ></div>
      <nuxt-link
        :external="true"
        :class="`n-${vars.buttonTypeText} tw-hidden tw-self-center xl:tw-mb-12 xl:tw-block`"
        :to="vars.buttonLinkUrl"
        v-if="vars.buttonLinkUrl"
      >
        {{ vars.buttonLabelText }}
      </nuxt-link>

      <!-- Slider for mobile -->
      <div class="tw-relative tw-flex tw-h-full tw-w-full tw-flex-col tw-gap-10">
        <div class="content-container">
          <div class="swiper-wrapper">
            <Swiper
              :key="'property-swiper-' + properties.length"
              :modules="[SwiperPagination]"
              :pagination="false"
              :slides-per-view="1"
              :space-between="20"
              effect="fade"
              :clickable="true"
              :watch-overflow="true"
              @slideChange="onSlideChange"
              :breakpoints="{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 2,
                  spaceBetween: 24,
                },
                1280: {
                  slidesPerView: 3,
                  spaceBetween: 24,
                },
              }"
              @swiper="onSwiper"
              class="tw-w-full"
            >
              <SwiperSlide v-for="(property, index) in properties" :key="`latestproperties-property-${index}`">
                <theme5-properties-property-list-item
                  :property="property"
                  :is-match-information-hidden="true"
                  version="v2"
                  :index="index"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
        <div>
          <LibrarySliderPagination
            :swiper="swiper"
            variant="v6"
            :can-paginate-back="canPaginateBack"
            :can-paginate-next="canPaginateNext"
          />
        </div>
      </div>

      <nuxt-link
        :external="true"
        :class="`n-${vars.buttonTypeText} tw-mt-6 tw-self-center xl:tw-hidden`"
        :to="vars.buttonLinkUrl"
        v-if="vars.buttonLinkUrl"
      >
        {{ vars.buttonLabelText }}
      </nuxt-link>
    </div>
  </section>

  <div
    v-if="variants.v2 === variant && sidebarComponents.length > 0"
    :style="`border-radius: var(--rounded); background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="tw-flex tw-w-full tw-max-w-none tw-flex-col tw-items-center lg:tw-max-w-none lg:tw-items-center">
      <div
        class="tw-flex tw-flex-wrap tw-justify-start tw-self-start tw-px-5 tw-pt-5 tw-text-start tw-text-black xl:tw-gap-4"
        v-html="vars.titleHtml"
      ></div>
      <nuxt-link
        :external="true"
        :class="`n-${vars.buttonTypeText} tw-mx-5 tw-mt-5 tw-hidden tw-self-start xl:tw-mb-6 xl:tw-block`"
        :to="vars.buttonLinkUrl"
        v-if="vars.buttonLinkUrl"
      >
        {{ vars.buttonLabelText }}
      </nuxt-link>

      <!-- Slider for mobile -->
      <div class="tw-relative tw-flex tw-h-full tw-w-full tw-flex-col tw-gap-6 tw-pb-6">
        <div class="content-container">
          <div class="swiper-wrapper">
            <Swiper
              :key="'property-swiper-' + properties.length"
              :modules="[SwiperPagination]"
              :pagination="false"
              :slides-per-view="1"
              :space-between="20"
              effect="fade"
              :clickable="true"
              :watch-overflow="true"
              @slideChange="onSlideChange"
              @swiper="onSwiper"
              class="tw-w-full"
            >
              <SwiperSlide v-for="(property, index) in properties" :key="`latestproperties-property-${index}`">
                <theme5-properties-property-list-item
                  :property="property"
                  :is-match-information-hidden="true"
                  version="v2"
                  :index="index"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
        <div>
          <LibrarySliderPagination
            :swiper="swiper"
            variant="v6"
            :can-paginate-back="canPaginateBack"
            :can-paginate-next="canPaginateNext"
          />
        </div>
      </div>

      <nuxt-link
        :external="true"
        :class="`n-${vars.buttonTypeText} tw-mt-6 tw-self-center xl:tw-hidden`"
        :to="vars.buttonLinkUrl"
        v-if="vars.buttonLinkUrl"
      >
        {{ vars.buttonLabelText }}
      </nuxt-link>
    </div>
  </div>

  <section
    v-if="variants.v3 === variant && sidebarComponents.length === 0"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="tw-flex tw-w-full tw-max-w-lg tw-flex-col tw-items-center tw-text-black lg:tw-max-w-none">
      <div
        class="tw-flex tw-flex-col tw-items-start tw-justify-between tw-gap-4 tw-self-start lg:tw-w-full lg:tw-flex-row lg:tw-items-center"
      >
        <h2 class="n-title-primary">{{ vars.titleText }}</h2>
        <nuxt-link :external="true" :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText}`">{{
          vars.buttonLabelText
        }}</nuxt-link>
      </div>
      <div class="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-gap-10 tw-pt-10 lg:tw-flex-col-reverse">
        <Swiper
          :modules="[SwiperPagination]"
          :pagination="false"
          :slides-per-view="1"
          :space-between="20"
          effect="fade"
          :clickable="true"
          :watch-overflow="true"
          :loop="true"
          @slideChange="onSlideChange"
          :breakpoints="{
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          }"
          @swiper="onSwiper"
          class="tw-w-full tw-max-w-lg lg:tw-max-w-full"
        >
          <SwiperSlide
            v-for="(property, index) in properties"
            :key="`latestproperties-property-${index}`"
            class="!tw-flex !tw-h-auto"
          >
            <theme5-properties-property-list-item
              :property="property"
              :is-match-information-hidden="true"
              :feature-count-number="vars.featureCountNumber"
              :index="index"
              :component="component"
              :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
              version="v3"
            />
          </SwiperSlide>
          <div class="controls">
            <div
              data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569daf"
              class="slide-left-arrow w-slider-arrow-left"
              :isDisabled="!canPaginateBack"
              @click="() => swiper.slidePrev()"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.011 3.49956C16.1418 3.6335 16.2151 3.81332 16.2151 4.00056C16.2151 4.18781 16.1418 4.36762 16.011 4.50156L8.70149 12.0001L16.011 19.4971C16.1418 19.631 16.2151 19.8108 16.2151 19.9981C16.2151 20.1853 16.1418 20.3651 16.011 20.4991C15.9474 20.5644 15.8714 20.6163 15.7874 20.6517C15.7034 20.6872 15.6132 20.7054 15.522 20.7054C15.4308 20.7054 15.3406 20.6872 15.2566 20.6517C15.1726 20.6163 15.0966 20.5644 15.033 20.4991L7.25999 12.5236C7.12347 12.3835 7.04706 12.1957 7.04706 12.0001C7.04706 11.8045 7.12347 11.6166 7.25999 11.4766L15.033 3.50106C15.0966 3.43575 15.1726 3.38383 15.2566 3.34839C15.3406 3.31294 15.4308 3.29468 15.522 3.29468C15.6132 3.29468 15.7034 3.31294 15.7874 3.34839C15.8714 3.38383 15.9474 3.43575 16.011 3.50106V3.49956Z"
                  fill="#6EADAB"
                />
              </svg>
              <div class="slide-circle slider-circle-transform"></div>
            </div>
            <div
              data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569db1"
              class="slide-right-arrow w-slider-arrow-right"
              :isDisabled="!canPaginateNext"
              @click="() => swiper.slideNext()"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.98901 3.49956C7.85817 3.6335 7.78491 3.81332 7.78491 4.00056C7.78491 4.18781 7.85817 4.36762 7.98901 4.50156L15.2985 12.0001L7.98901 19.4971C7.85817 19.631 7.78491 19.8108 7.78491 19.9981C7.78491 20.1853 7.85817 20.3651 7.98901 20.4991C8.0526 20.5644 8.12864 20.6163 8.21263 20.6517C8.29661 20.6872 8.38685 20.7054 8.47801 20.7054C8.56917 20.7054 8.65941 20.6872 8.74339 20.6517C8.82738 20.6163 8.90342 20.5644 8.96701 20.4991L16.74 12.5236C16.8765 12.3835 16.9529 12.1957 16.9529 12.0001C16.9529 11.8045 16.8765 11.6166 16.74 11.4766L8.96701 3.50106C8.90342 3.43575 8.82738 3.38383 8.74339 3.34839C8.65941 3.31294 8.56917 3.29468 8.47801 3.29468C8.38685 3.29468 8.29661 3.31294 8.21263 3.34839C8.12864 3.38383 8.0526 3.43575 7.98901 3.50106V3.49956Z"
                  fill="#6EADAB"
                />
              </svg>
              <div class="slide-circle right"></div>
            </div>
          </div>
        </Swiper>
      </div>
    </div>
  </section>

  <div
    v-if="variants.v3 === variant && sidebarComponents.length > 0"
    class="tw-mt-5 tw-px-7 tw-py-6"
    :style="`border-radius: var(--rounded); background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text_primary)'}`"
  >
    <div class="tw-flex tw-w-full tw-flex-col tw-items-start">
      <h3 class="n-title-primary tw-mb-4">{{ vars.titleText }}</h3>
      <Swiper
        :modules="[SwiperPagination]"
        :pagination="false"
        :slides-per-view="1"
        :space-between="20"
        effect="fade"
        :clickable="true"
        :watch-overflow="true"
        :loop="false"
        @slideChange="onSlideChange"
        :breakpoints="{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        }"
        @swiper="onSwiper"
        class="tw-w-full"
      >
        <SwiperSlide v-for="(property, index) in properties" :key="`latestproperties-property-${index}`" class="">
          <theme5-properties-property-list-item
            :property="property"
            :is-match-information-hidden="true"
            :feature-count-number="vars.featureCountNumber"
            :index="index"
            :component="component"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
            version="v3"
            :is-sidebar-component="true"
          />
        </SwiperSlide>
        <div class="controls">
          <div
            data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569daf"
            class="slide-left-arrow w-slider-arrow-left"
            :isDisabled="!canPaginateBack"
            @click="() => swiper.slidePrev()"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.011 3.49956C16.1418 3.6335 16.2151 3.81332 16.2151 4.00056C16.2151 4.18781 16.1418 4.36762 16.011 4.50156L8.70149 12.0001L16.011 19.4971C16.1418 19.631 16.2151 19.8108 16.2151 19.9981C16.2151 20.1853 16.1418 20.3651 16.011 20.4991C15.9474 20.5644 15.8714 20.6163 15.7874 20.6517C15.7034 20.6872 15.6132 20.7054 15.522 20.7054C15.4308 20.7054 15.3406 20.6872 15.2566 20.6517C15.1726 20.6163 15.0966 20.5644 15.033 20.4991L7.25999 12.5236C7.12347 12.3835 7.04706 12.1957 7.04706 12.0001C7.04706 11.8045 7.12347 11.6166 7.25999 11.4766L15.033 3.50106C15.0966 3.43575 15.1726 3.38383 15.2566 3.34839C15.3406 3.31294 15.4308 3.29468 15.522 3.29468C15.6132 3.29468 15.7034 3.31294 15.7874 3.34839C15.8714 3.38383 15.9474 3.43575 16.011 3.50106V3.49956Z"
                fill="#6EADAB"
              />
            </svg>
            <div class="slide-circle slider-circle-transform"></div>
          </div>
          <div
            data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569db1"
            class="slide-right-arrow w-slider-arrow-right"
            :isDisabled="!canPaginateNext"
            @click="() => swiper.slideNext()"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.98901 3.49956C7.85817 3.6335 7.78491 3.81332 7.78491 4.00056C7.78491 4.18781 7.85817 4.36762 7.98901 4.50156L15.2985 12.0001L7.98901 19.4971C7.85817 19.631 7.78491 19.8108 7.78491 19.9981C7.78491 20.1853 7.85817 20.3651 7.98901 20.4991C8.0526 20.5644 8.12864 20.6163 8.21263 20.6517C8.29661 20.6872 8.38685 20.7054 8.47801 20.7054C8.56917 20.7054 8.65941 20.6872 8.74339 20.6517C8.82738 20.6163 8.90342 20.5644 8.96701 20.4991L16.74 12.5236C16.8765 12.3835 16.9529 12.1957 16.9529 12.0001C16.9529 11.8045 16.8765 11.6166 16.74 11.4766L8.96701 3.50106C8.90342 3.43575 8.82738 3.38383 8.74339 3.34839C8.65941 3.31294 8.56917 3.29468 8.47801 3.29468C8.38685 3.29468 8.29661 3.31294 8.21263 3.34839C8.12864 3.38383 8.0526 3.43575 7.98901 3.50106V3.49956Z"
                fill="#6EADAB"
              />
            </svg>
            <div class="slide-circle right"></div>
          </div>
        </div>
      </Swiper>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertiesMixin } from '~/units/properties/mixins/properties.mixin';
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';

export default defineNuxtComponent({
  name: 'Theme5LatestProperties',

  mixins: [ComponentMixin, PropertiesMixin],

  data() {
    return {
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
    };
  },

  async setup(props) {
    await fetchPropertiesManager(props.component, null);
  },

  mounted() {
    this.onSlideChange();
  },

  methods: {
    onSwiper(swiper: object) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
  },

  computed: {
    ...mapState(useWebsiteStore, ['sidebarComponents']),
  },
});
</script>
